import { __assign, __rest } from "tslib";
import React, { useMemo } from 'react';
import { View, TouchableOpacity, Image, Dimensions } from 'react-native';
import { textStyle } from '../../../v2/theme';
import { PnmacText, PnmacMediaQuery, PnmacSelect, PnmacUIButton, PnmacModal } from 'pnmac-universal-components';
import { isEmptyOrSpaces, testID } from '../../../utils.js';
import { TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, TrackerHitTypeLID_ENUM, UserLanguage_ENUM } from '../../../redux/events/events';
export default function DeleteBankAccountNative(_a) {
  var _this = this;
  var bankAccounts = _a.bankAccounts,
    layout = _a.layout,
    deleteAccount = _a.deleteAccount,
    setDeleteAccount = _a.setDeleteAccount,
    deleteId = _a.deleteId,
    setDeleteId = _a.setDeleteId,
    deleteBankAccountFunc = _a.deleteBankAccountFunc,
    translations = _a.translations,
    trackerDispatcher = _a.trackerDispatcher,
    isOtp = _a.isOtp,
    rest = __rest(_a, ["bankAccounts", "layout", "deleteAccount", "setDeleteAccount", "deleteId", "setDeleteId", "deleteBankAccountFunc", "translations", "trackerDispatcher", "isOtp"]);
  var _b = React.useState(false),
    showDeletePopup = _b[0],
    setShowDeletePopup = _b[1];
  var _c = React.useState({
      deleteAccountNumber: undefined
    }),
    deleteBankAccount = _c[0],
    setDeleteBankAccount = _c[1];
  var _d = Dimensions.get('window'),
    fontSize = _d.fontSize,
    width = _d.width,
    height = _d.height;
  var setDeleteBankAccountDetails = function () {
    var selectedBankAccount = bankAccounts === null || bankAccounts === void 0 ? void 0 : bankAccounts.find(function (t) {
      return t.bankAccountNumber == deleteBankAccount.deleteAccountNumber || t.unmaskedAccountNumber == deleteBankAccount.deleteAccountNumber;
    });
    setDeleteAccount(__assign(__assign({}, selectedBankAccount), {
      bankRoutingNumber: selectedBankAccount.routingTransitNumber,
      bankAccountName: selectedBankAccount.accountName,
      bankAccountType: selectedBankAccount.bankAccountType,
      bankAccountNumber: selectedBankAccount.accountNumber,
      confirmAccountNumber: selectedBankAccount.accountNumber,
      bankAccountId: selectedBankAccount.bankAccountId,
      unmaskedAccountNumber: selectedBankAccount.unmaskedAccountNumber
    }));
    setDeleteId(selectedBankAccount.bankAccountNumber);
    setShowDeletePopup(true);
  };
  var deleBankAccount = function () {
    setShowDeletePopup(false);
    deleteBankAccountFunc();
  };
  var getBankDropDown = React.useMemo(function () {
    var _a;
    return (_a = bankAccounts === null || bankAccounts === void 0 ? void 0 : bankAccounts.map(function (accounts, index) {
      var _a, _b, _c, _d;
      return {
        value: (_a = accounts.bankAccountNumber) !== null && _a !== void 0 ? _a : accounts.unmaskedAccountNumber,
        key: (_b = accounts.bankAccountNumber) !== null && _b !== void 0 ? _b : accounts.unmaskedAccountNumber,
        label: "".concat((accounts === null || accounts === void 0 ? void 0 : accounts.bankAccountType) === 201286 ? "Checking Account" : (accounts === null || accounts === void 0 ? void 0 : accounts.bankAccountType) === 201287 ? "Saving Account" : "", " x").concat((_d = (_c = accounts.accountNumber) === null || _c === void 0 ? void 0 : _c.toString()) === null || _d === void 0 ? void 0 : _d.slice(-4))
      };
    })) !== null && _a !== void 0 ? _a : [];
  }, []);
  var getDeleteConfirmationPopup = function (matches) {
    var _a, _b;
    return /*#__PURE__*/React.createElement(PnmacModal, __assign({
      open: showDeletePopup,
      style: {
        display: 'flex'
      }
    }, testID('removePaymentMethodModal')), /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        height: height * 0.4,
        alignItems: "center",
        outline: "transparent",
        flexDirection: 'column',
        borderRadius: 5,
        backgroundColor: '#FFF',
        borderColor: '#C1C1C1',
        marginBottom: '10%',
        padding: width * 0.012
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        alignSelf: 'flex-end',
        margin: width * 0.035
      }
    }, /*#__PURE__*/React.createElement(TouchableOpacity, __assign({}, testID('removePaymentMethodDropdown'), {
      onPress: function () {
        isOtp ? trackerDispatcher === null || trackerDispatcher === void 0 ? void 0 : trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Remove account Modal- X|Mobile', -1, deleteAccount.accountNumber, false) : trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "AutoPay/Remove account Modal- X|Mobile", -1, "", false);
        setDeleteAccount({
          bankRoutingNumber: '',
          bankAccountName: '',
          bankAccountType: '',
          bankAccountNumber: '',
          confirmAccountNumber: '',
          bankAccountId: '',
          unmaskedAccountNumber: ''
        });
        setShowDeletePopup(false);
      }
    }), /*#__PURE__*/React.createElement(Image, {
      alt: "Icon close",
      source: require("../../../assets/icon-close-x-darkGray.png")
    }))), /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: height * 0.02,
        marginTop: height * 0.04
      }
    }, /*#__PURE__*/React.createElement(Image, {
      alt: "View details",
      source: require("../../../assets/icon-danger-yellow.jpg")
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: height * 0.01,
        marginLeft: width * 0.02,
        marginRight: width * 0.02
      }
    }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('removepaymentmethod'), {
      adjustsFontSizeToFit: true,
      numberOfLines: 1,
      style: {
        color: '#333333',
        fontSize: 25 * (width / 320),
        fontFamily: "Montserrat",
        fontWeight: 'bold'
      }
    }), "Remove Payment Method")), /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: height * 0.02,
        marginLeft: width * 0.02,
        marginRight: width * 0.02
      }
    }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('removepaymentmethodconfirmation'), {
      adjustsFontSizeToFit: true,
      numberOfLines: 1,
      style: {
        fontSize: 13,
        color: '#5C5C5C',
        alignSelf: 'center'
      }
    }), translations.PaymentMethodsRemovePaymentMethodConfirmationMessage), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('deletebank account'), {
      adjustsFontSizeToFit: true,
      numberOfLines: 1,
      style: {
        fontSize: 13,
        color: '#5C5C5C',
        alignSelf: 'center'
      }
    }), "".concat((deleteAccount === null || deleteAccount === void 0 ? void 0 : deleteAccount.bankAccountType) === 201286 ? "Checking Account" : (deleteAccount === null || deleteAccount === void 0 ? void 0 : deleteAccount.bankAccountType) === 201287 ? "Saving Account" : "", " x").concat((_b = (_a = deleteAccount.accountNumber) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.slice(-4)), "?")), /*#__PURE__*/React.createElement(View, {
      style: {
        bottom: 10,
        position: 'absolute'
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({
      idTag1: 'btnDelete',
      mode: "contained",
      style: {
        marginLeft: matches.small ? 0 : 10,
        marginRight: matches.small ? 0 : 20,
        minWidth: "93%",
        borderWidth: 1,
        backgroundColor: '#FFF',
        borderColor: '#CC0814',
        borderRadius: 5,
        height: 45,
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'center'
      }
    }, testID('removePaymentMethodRemoveButton'), {
      onPress: function () {
        deleBankAccount();
        isOtp ? trackerDispatcher === null || trackerDispatcher === void 0 ? void 0 : trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, 'OTP/Remove account Modal- Remove|Mobile', -1, deleteAccount.accountNumber, false) : trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "AutoPay/Remove account Modal- Remove|Mobile", -1, "", false);
      }
    }), /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('removepayment'), {
      style: {
        color: '#D1221D',
        fontFamily: "Montserrat",
        fontWeight: 'bold'
      }
    }), translations.PaymentMethodsRemovePaymentMethod)))));
  };
  return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
    onRefresh: function () {
      _this.props.authenticate(false);
    },
    refreshing: layout.reloadingData,
    queries: {
      small: "(max-width: 599px)",
      medium: "(min-width: 600px) and (max-width: 1199px)",
      large: "(min-width: 1200px)"
    }
  }, function (matches) {
    return /*#__PURE__*/React.createElement(View, null, getDeleteConfirmationPopup(matches), /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(View, {
      style: {
        backgroundColor: "#FFFFFF",
        display: "flex",
        flexDirection: matches.small ? "column" : "row",
        alignItems: "left",
        paddingLeft: 10,
        paddingBottom: 5,
        borderBottomWidth: 1,
        borderColor: '#C1C1C1',
        margin: 15
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        padding: 10
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: 5,
        marginRight: 5,
        // marginLeft: 5,
        padding: 10,
        paddingTop: 0,
        marginTop: matches.small ? 10 : undefined
      }
    }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('dropdown'), {
      style: textStyle.formBody
    }), "Payment Method")), /*#__PURE__*/React.createElement(PnmacSelect, __assign({
      accessibilityLabel: "Bank account",
      key: 'deleteSelect1',
      idTag1: 'dropDownDeleteAccount',
      idTag2: 'dropDownDeleteAccount2'
    }, testID('removePaymentMethodSelect'), {
      useNativeAndroidPickerStyle: Platform.select({
        android: true,
        web: true,
        ios: true
      }),
      Icon: layout.mobile && Platform.OS === 'ios' ? function () {
        return /*#__PURE__*/React.createElement(Image, {
          alt: "Click to expand section",
          style: {
            marginTop: 3,
            marginRight: 5,
            width: 12,
            height: 8
          },
          source: require("../../../assets/expand-icon.png")
        });
      } : function () {
        return null;
      },
      style: {
        viewContainer: __assign({}, {
          justifyContent: "center",
          alignItems: "flex-start",
          backgroundColor: "white",
          borderRadius: 10,
          height: 41,
          borderColor: '#707070',
          borderWidth: 1,
          marginLeft: 5,
          marginRight: Platform.select({
            android: 12,
            ios: 0
          })
        }),
        inputAndroid: {
          color: "#707070",
          width: '100%',
          paddingLeft: 15,
          paddingRight: 10
        },
        inputIOS: {
          color: "#707070",
          paddingLeft: 15,
          paddingRight: 10
        }
      },
      items: getBankDropDown || [],
      value: deleteBankAccount.deleteAccountNumber == undefined ? '' : deleteBankAccount.deleteAccountNumber,
      onValueChange: function (value) {
        {
          if (!isEmptyOrSpaces(value)) {
            setDeleteBankAccount({
              deleteAccountNumber: value
            });
          }
        }
      }
    })), /*#__PURE__*/React.createElement(View, {
      style: {
        marginBottom: 10,
        marginRight: 5,
        marginTop: matches.small ? 10 : undefined,
        paddingBottom: 30,
        marginLeft: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacText, __assign({}, testID('removepaymentmessage'), {
      style: {
        fontSize: 14,
        color: '#8B8B8B'
      }
    }), translations.PaymentMethodsRemovePaymentMethodMessage))))), /*#__PURE__*/React.createElement(View, {
      style: {
        marginLeft: 25,
        marginTop: 5,
        marginRight: 25
      }
    }, /*#__PURE__*/React.createElement(PnmacUIButton, __assign({}, testID('setDeleteBankAccountDetails'), {
      idTag1: 'btnDelete',
      mode: "contained",
      style: {
        marginLeft: matches.small ? 0 : 13,
        marginRight: matches.small ? 0 : 30,
        minWidth: "40%",
        height: 43,
        justifyContent: 'center',
        alignItems: 'center'
      },
      disabled: deleteBankAccount.deleteAccountNumber == undefined || deleteBankAccount.deleteAccountNumber == '',
      onPress: function () {
        setDeleteBankAccountDetails();
        trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "AutoPay/Remove account-Remove|Mobile", -1, "", false);
      }
    }), translations.PaymentMethodsRemovePaymentMethod)));
  });
}